import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHeaderInterceptor } from './handler/auth-header.interceptor';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationStart, Router } from '@angular/router';
import { StaticMemory } from './handler/static_memory';
import { LoadingModule } from './loading/loading.module';
import { ElementWidgetsModule } from './element-widgets/element-widgets.module';
import {} from './pages/product/product.component';
import { MatChipsModule } from '@angular/material/chips';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AUTHGWCONSTANTS } from './authorization/authconstatnts';
import { GoogleMapLoaderService } from './handler/google-map-loader';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule, VAPID_KEY } from '@angular/fire/compat/messaging';
import { environment } from 'src/environments/environment';
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CarouselModule,
    FlexLayoutModule,
    FormsModule,
    MatChipsModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    ElementWidgetsModule,
    LoadingModule,
    DragScrollComponent,
    DragScrollItemDirective,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule
  ],
  providers: [
    shareIcons(),
    { provide: VAPID_KEY, useValue: environment.fcmVapidKey },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
  constructor(private router: Router) {
    GoogleMapLoaderService.load().then(() => {});
    if (localStorage.getItem(AUTHGWCONSTANTS.xenAuth)) {
      sessionStorage.clear();
      StaticMemory.isAuthVerified = false;
    } else {
      StaticMemory.isAuthVerified = true;
    }
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        sessionStorage.setItem(StaticMemory.xRoute, event.url);
        // if (event.url === '' && StaticMemory.isAuthVerified) {
        //   this.router.navigate(['']);
        // }
      }
    });
  }
}
